import(/* webpackMode: "eager" */ "/Users/paulmorin/dev/Moulin de la Louve/mgt-app/src/app/global-error.tsx");
